import { createContext } from 'react';

const CMSRouteParamsContext = createContext({});

export default CMSRouteParamsContext;
